export default __webpack_public_path__ + "static/media/filterByDate.fe5234da.svg";